<template lang="pug">
  div
    el-row
      divider(label="Dados da portaria")
    el-row(type='flex')
      el-col(:span="12").container-input
        validation-provider(rules="required|max:6", v-slot="{ errors }")
          app-label(label="N° do D.O.E:", :required="true")
          el-input.input(
            v-model="numeroPublicacao"
            :class="{'erro' : errors.length}"
            :onkeypress="onlyInputNumbers"
          )
          span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Data de Publicação:", :required="true")
            el-input.input(
            v-model="dataPublicacao"
            :class="{'erro' : errors.length}"
            type="date"
            )
            span.help.erro {{ errors[0] }}
      el-col(:span="12").container-input
        app-label(label="Nº da portaria:", :required="true")
        el-input.input(
          v-model="numeroPortaria"
          disabled
        )
</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'
import utils from '@/utils/utils'
import AppOnlyInputNumbers from '@/components/mixins/AppOnlyInputNumbers'

export default {
  components: {
    Divider,
    AppLabel
  },

  mixins: [AppOnlyInputNumbers],

  props: {
    portaria: {
      required: true,
      type: Object
    }
  },
  computed: {
    numeroPublicacao: {
      get: function () {
        if (this.portaria?.numeroEdicaoPublicacao) {
          return this.portaria.numeroEdicaoPublicacao
        }
        return ''
      },
      set: function (value) {
        this.portaria.numeroEdicaoPublicacao = value
      }
    },

    dataPublicacao: {
      get: function () {
        if (this.portaria?.dataPublicacao) {
          return utils.formatDate(this.portaria.dataPublicacao, 'yyyy-MM-DD')
        }
        return ''
      },

      set: function (value) {
        this.portaria.dataPublicacao = value
      }
    },
    numeroPortaria () {
      return this.portaria.numeroPortaria
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container-input {
  margin-right: 20px;
}

.input-suffix {
  padding: 10px;
}

>>> .el-input-group__append {
  color: $--color-text-secondary;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/oficio/DadosPortaria.vue